import React from 'react';
import { WithPermissions, MenuItemLink } from "react-admin";
import LinkIcon from '@material-ui/icons/Link';

import accounts from "../../accounts";
import transactions from "../../transactions";

// Promoter Menu
export const PromoterStaffSideMenu = ({ handleToggle, menuBusiness, menuDocs, menuCatalog, open, translate, onMenuClick }) => (
    <WithPermissions
        render={({ permissions }) => (
            permissions === 'promoter_staff'
                ? <> 
                    <MenuItemLink
                        to={`/invitation-link`}
                        primaryText="Invitation Link"
                        leftIcon={<LinkIcon/>}
                        onClick={onMenuClick}
                    />
                </>
                : null
        )}
    >
    </WithPermissions>
)